import { graphql } from 'react-apollo';
import { AddDemoActivityMutation } from './queries';

export default graphql<
    { id: string },
    any,
    { id: string },
    { addDemoActivity: () => void }
>(AddDemoActivityMutation, {
    props: ({ ownProps, mutate }) => ({
        ...ownProps,
        addDemoActivity: () => {
            if (!mutate) {
                throw new Error('No mutate function provided');
            }

            return mutate({
                variables: { id: ownProps.id }
            });
        }
    })
});



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/withAddDemoActivity.tsx